import { platformLinkingSelector } from 'modules/platform-linking/store/selectors';
import React, { FC, useCallback } from 'react';
import { Button } from '@mui/material';
import { PlatformLinkingStatus } from 'modules/platform-linking/enums';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './LinkingInProgressModalActions.styles';
import { useDispatch, useSelector } from 'react-redux';
import { modalsReducers } from 'app/store/modal/slice';
import { ModalName } from 'app/enums';

interface LinkingProgressModalActionsProps {
  status: PlatformLinkingStatus;
}

export const LinkingProgressModalActions: FC<LinkingProgressModalActionsProps> = ({ status }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const redirectPath = useSelector(platformLinkingSelector.internalRedirect);

  const onSuccessLinkingHandler = useCallback(() => {
    dispatch(modalsReducers.closeModal(ModalName.PlatformLinking));

    if (redirectPath) {
      navigate(redirectPath);
    }
  }, [dispatch, navigate, redirectPath]);

  const onCloseHandler = useCallback(
    () => dispatch(modalsReducers.closeModal(ModalName.PlatformLinking)),
    [dispatch]
  );

  if (status === PlatformLinkingStatus.Success) {
    return (
      <Button
        onClick={onSuccessLinkingHandler}
        className={classes.root}
        fullWidth
        variant="contained"
        color="primary"
      >
        Awesome!
      </Button>
    );
  }

  return (
    <Button
      onClick={onCloseHandler}
      className={classes.root}
      fullWidth
      variant="outlined"
      color="secondary"
    >
      Close
    </Button>
  );
};
